import { Component, inject, signal, effect } from '@angular/core';
import {AdsService} from "../../../core/services/ads.service";
import {UserService} from "../../../core/services/user.service";
import {Ad} from "../../../core/models/cms/ads.model";
import {animate, state, style, transition, trigger} from "@angular/animations";


@Component({
  selector: 'app-sticky',
  standalone: false,
  templateUrl: './sticky.component.html',
  styleUrl: './sticky.component.scss',
  animations: [
    trigger('slideUpDown', [
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1,
        height: '90px'
      })),
      state('hidden', style({
        transform: 'translateY(100%)',
        opacity: 0,
        height: '0px'
      })),
      transition('visible => hidden', [
        animate('300ms ease-in-out')
      ]),
      transition('hidden => visible', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class StickyComponent {
  private readonly adsService = inject(AdsService);
  private readonly userService = inject(UserService);
  readonly CDN = inject<string>('CDN' as any);

  selected = signal<Ad | null>(null);
  hidden = signal(false);

  constructor() {
    effect(() => {
      const allStickies = this.adsService.stickyAds();

      if (allStickies.length === 0) {
        this.selected.set(null);
        return;
      }

      if (this.selected() !== null) return;

      const pool = this.buildPool(allStickies);
      const lastId = this.adsService.lastShownStickyId();

      let nextAd: Ad;

      if (lastId && pool.length > 1) {
        const candidates = pool.filter(a => a.id !== lastId);
        nextAd = candidates[Math.floor(Math.random() * candidates.length)];
      } else {
        nextAd = pool[Math.floor(Math.random() * pool.length)];
      }

      this.selected.set(nextAd);
      this.adsService.lastShownStickyId.set(nextAd.id);
    });
  }

  private buildPool(allAds: Ad[]): Ad[] {
    if (this.userService.isAdmin()) return allAds;
    const prio = allAds.filter(a => a.prioritized);
    return prio.length > 0 ? prio : allAds;
  }

  toggleBanner(): void {
    this.hidden.update(h => !h);
  }
}
